import requestAction from '../../utils/requestAction'

export const fetchVendors = (params: string = "") =>
  requestAction('VENDOR_LIST', params)(`vendors`, 'GET')
